import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let similarJobsSwiperWr = document.querySelectorAll('.similar-jobs-swiper-wr');
similarJobsSwiperWr.forEach((el) => {
  if (el) {
    const throttle = (callback, delay = 200) => {
      let isThrottled = false;
      let pendingArgs = null;
      let pendingContext = null;

      const runPending = () => {
        callback.apply(pendingContext, pendingArgs || []);
        pendingArgs = null;
        pendingContext = null;
      };

      return function throttledCallback(...args) {
        if (isThrottled) {
          pendingArgs = args;
          pendingContext = this;
          return;
        }

        callback.apply(this, args);
        isThrottled = true;

        setTimeout(() => {
          isThrottled = false;

          if (pendingArgs) {
            runPending();
            isThrottled = true;

            setTimeout(() => {
              isThrottled = false;
            }, delay);
          }
        }, delay);
      };
    };

    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    const alignSimilarJobsTitles = () => {
      const titles = Array.from(el.querySelectorAll('.job-card.second-type .job-card__title'));

      if (!titles.length) {
        return;
      }

      let maxHeight = 0;

      titles.forEach((title) => {
        title.style.minHeight = '';
      });

      titles.forEach((title) => {
        maxHeight = Math.max(maxHeight, title.offsetHeight);
      });

      titles.forEach((title) => {
        title.style.minHeight = `${maxHeight}px`;
      });
    };

    const throttledAlignSimilarJobsTitles = throttle(alignSimilarJobsTitles, 200);

    const alignSimilarJobsTexts = () => {
      const texts = Array.from(el.querySelectorAll('.job-card.second-type .job-card__text'));

      if (!texts.length) {
        return;
      }

      let maxHeight = 0;

      texts.forEach((text) => {
        text.style.minHeight = '';
      });

      texts.forEach((text) => {
        maxHeight = Math.max(maxHeight, text.offsetHeight);
      });

      texts.forEach((text) => {
        text.style.minHeight = `${maxHeight}px`;
      });
    };

    const throttledAlignSimilarJobsTexts = throttle(alignSimilarJobsTexts, 200);

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true,
      observeParents: true,
      spaceBetween: 16,
      slidesPerView: 1,
      speed: 500,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      on: {
        init() {
          alignSimilarJobsTitles();
          alignSimilarJobsTexts();
        },
        resize() {
          throttledAlignSimilarJobsTitles();
          throttledAlignSimilarJobsTexts();
        },
        observerUpdate() {
          throttledAlignSimilarJobsTitles();
          throttledAlignSimilarJobsTexts();
        },
        update() {
          throttledAlignSimilarJobsTitles();
          throttledAlignSimilarJobsTexts();
        },
      },
      breakpoints: {
        640: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        1200: {
          spaceBetween: 32,
          slidesPerView: 2,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      }
    });

    alignSimilarJobsTitles();
    alignSimilarJobsTexts();
    window.addEventListener('resize', throttledAlignSimilarJobsTitles);
    window.addEventListener('resize', throttledAlignSimilarJobsTexts);

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        alignSimilarJobsTitles();
        alignSimilarJobsTexts();
      });
    }

    swiperObserver(swiper);
  }
});
